import { render, staticRenderFns } from "./TrackShipment.vue?vue&type=template&id=6817ba60&"
import script from "./TrackShipment.vue?vue&type=script&lang=js&"
export * from "./TrackShipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports